import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import StartPage from './components/StartPage';
import TestPage from './components/TestPage';
import ResultsPage from './components/ResultsPage';
import ImpressumPage from './components/ImpressumPage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <Routes>
            <Route path="/" element={<StartPage />} />
            <Route path="/test" element={<TestPage />} />
            <Route path="/results" element={<ResultsPage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
          </Routes>
        </motion.div>
      </div>
    </Router>
  );
}

export default App;